import React from 'react';
import { Button } from 'antd';
import { changePrimaryThemeColour } from '../../helpers';
import { SketchPicker } from 'react-color';

const ColourPicker = () => {
  const [primaryColour, setPrimaryColour] = React.useState('#1DA57A');
  return (
    <>
      <SketchPicker
        color={primaryColour}
        onChange={(value) => {
          setPrimaryColour(value.hex);
          changePrimaryThemeColour(value.hex);
        }}
      />
      <Button type="primary">Button</Button>
    </>
  );
};

export default ColourPicker;
